import Vue from 'vue'
import App from './App.vue'
import router from './router'
import moment from 'moment'
import Cookies from 'js-cookie'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/index.less'
import request from './utils/request_new'
import deepClone from './utils/deepClone'

Vue.config.productionTip = false
Vue.prototype.$moment = moment
Vue.prototype.$cookies = Cookies
Vue.prototype.$request = request
Vue.prototype.$deepClone = deepClone


Vue.use(ElementUI, { size: 'small', zIndex: 3000 })

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
